// REACT
import React, {Component} from 'react';

// REDUX
import {connect} from 'react-redux';
import * as actions from '../../actions/';

// VENDOR COMPONENTS
import AutoComplete from 'material-ui/AutoComplete';
import SearchIcon from 'material-ui/svg-icons/action/search';

// CUSTOM COMPONENTS
import { FluidSection } from 'components/FluidSection';
import { StretchCard } from 'components/StretchCard';
import { Content } from 'components/Content';
import SearchBarSC from './SearchBarSC';
import { Hero } from 'components/Hero';
import ServiceCard from '../ServiceCard/ServiceCard';
import ProviderCard from '../ProviderCardSection/ProviderCard';
import TagLine from '../Logo/TagLine';

// CONSTANTS
import { constants } from '../../constants/index';

// UTILS
import uniq from 'lodash/uniq';



  
class HeroSearch extends Component {

    constructor () {
        super();
        this.state = {
            width: 0,
            height: 0,
            searchInputValues: [],
        };
    }

      //for Mui Auto complete
    handleUpdateInput = (value) => {
        this.setState({
            searchInputValues: [
            value,
            // value + value,
            // value + value + value,
            ],
        });
        // document.getElementById('results').scrollIntoView();
    };



    componentWillMount() {
        this.props.getDBProviders();
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }
 
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);

    }
    
    componentDidMount(){
        // document.getElementById('top').scrollIntoView();
        // must load here not in AppRouter
        this.props.getDBProviders();
        this.props.getDBServices();
        this.props.getDBProviderCompanies();
        this.props.getDBServiceCategories();
        this.props.getDBServiceModules();
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

     
    render() {
        const {searchInputValues} = this.state;
        // TODO: note that serviceCategories shold be attached to services not experts in the future
        let filteredProvider = [];
        if (this.props.providers) { 
            filteredProvider = this.props.providers.filter(provider => {
                // console.log('provider', provider)
                let providerFullName = `${provider.name && provider.name.first} ${provider.name && provider.name.last}`;
                let providerDesignation = provider.designation;
                let expertise = provider.expertise;
                
                let fileredProviderMatch = false;
                        // provider.fullName.forEach(serviceCategory => {
                            if (searchInputValues && searchInputValues.indexOf(providerFullName) > -1) {
                                fileredProviderMatch = true;
                            } else if (searchInputValues && searchInputValues.indexOf(providerDesignation) > -1) {
                                fileredProviderMatch = true;
                            } else if (searchInputValues && searchInputValues.indexOf(expertise) > -1) {
                                fileredProviderMatch = true;
                            }
                        // })
                    return fileredProviderMatch;
                }
            );
        }

        let unFilteredProviders = [];
        if (this.props.providers) { 
                unFilteredProviders = this.props.providers.filter(provider => {
                    let providerFullName = `${provider.name && provider.name.first} ${provider.name && provider.name.last}`;
                    let fileredProviderMatch = false;
                        // expert.serviceCategories.forEach(serviceCategory =>{
                            if (! (searchInputValues && searchInputValues.indexOf(providerFullName) > -1)) {
                                fileredProviderMatch = true;
                            } 
                        // })
                    return fileredProviderMatch;
                }
            );
        }

        // console.log(searchInputValues)       
        let providerName = [];
        let providers = [];
        if (this.props.providers) { 
            providers = this.props.providers
            providerName = providers.map(provider => {
                // console.log('PROVIDER @ dataSource Nodes Expert Search', provider);
                if (provider.name) {
                    return (
                        `${provider.name.first} ${provider.name.last}`
                    )
                }
                return null;
            });
        }
        let providerDesignation = [];
        if (this.props.providers) { 
            providers = this.props.providers
            providerDesignation = providers.map(provider => (provider.designation));
        }

        let uniqueProviderDesignation = uniq(providerDesignation, 'id');

        let categoriesDataSourceNodes = [];
        if (this.props.serviceCategories) {
            categoriesDataSourceNodes = this.props.serviceCategories.map(categories => (categories.description));
        }
        let providerExpertise = [];
        if (this.props.providers) { 
            providers = this.props.providers
            providerExpertise = providers.map(provider => (provider.expertise));
        }
        
/*
{
                console.log('!!$$provider.designation', provider.designation)
                let providerDesignations = [];
                providerDesignations = providerDesignation.map(designations => {
                    console.log('!!$$designations', designations)
                    if (provider.designation != designations) {
                        return provider.designation;
                    }
                    return null;
                });
                console.log('!!$$providerDesignations', providerDesignations)
                return providerDesignations;
            }
*/

        // console.log('categoriesDataSourceNodes',categoriesDataSourceNodes)
        // console.log('allDataSourceNodes',allDataSourceNodes)
        // console.log('providerName',providerName)

        // const bothDataSourceNodes = providerName.concat(categoriesDataSourceNodes, providerDesignation);
        const allDataSourceNodes = [...providerName, ...uniqueProviderDesignation, ...providerExpertise];
            
        return (
            <div style={constants.layout.container}>
                <Hero
                    backgroundImageURL={'https://firebasestorage.googleapis.com/v0/b/cyno-telephysio-pilot.appspot.com/o/cynoAssets%2FheroImages%2FMatt_lg.jpg?alt=media&token=a72dcc64-7d4c-4b0e-a560-6dc9e7088c7f'} 
                    // mainTitleText="Your Health" 
                    // subTitleText="Anytime • Anywhere"
                    height={this.state.height/1.33} 
                    overlayColor='rgba(55, 157, 168, 0.55)'
                    center
                >
                    <TagLine
                        marginTop={-(this.state.height/9)}
                    />
                    { allDataSourceNodes &&
                        <SearchBarSC
                            hintText='Try “Physiotherapy”'
                            dataSource={allDataSourceNodes}
                            onUpdateInput={this.handleUpdateInput}
                            filter={AutoComplete.fuzzyFilter}
                            width={(this.state.width/1.1)}
                        >
                            <SearchIcon 
                                style={{ height: 27, width: 27, marginRight: 8, color: 'rgba(0, 0, 0, 0.3)', }}
                            />
                        </SearchBarSC>
                    }
                </Hero>

                <div name="results-second-element" id={'results'}>
                { filteredProvider && ( searchInputValues && searchInputValues.length > 0 ) &&
                    <FluidSection style={{ marginBottom: 10, marginTop: -130 }} sectionMinWidth={300} sectionMaxWidth={600}>
                        { filteredProvider &&
                            filteredProvider.map((provider)=>{
                                const providerService = this.props.services.map(service => {
                                    if (service.provider === provider.uid){
                                        const serviceProviderCompanyCards = this.props.companies.map(company => {
                                            if (service.company === company._id){
                                                return (
                                                    <ServiceCard
                                                        service={ service }
                                                        provider={ provider }
                                                        company={ company }
                                                    />
                                                );
                                            }
                                        })
                                        return serviceProviderCompanyCards.filter(card => card);
                                    }
                                })
                                return providerService.filter(card => card);
                            })
                        }
                    </FluidSection>
                }
                </div>
                { filteredProvider && ( searchInputValues && searchInputValues.length > 0 ) &&
                    <div>
                    <FluidSection style={{ marginBottom: 10 }} sectionMinWidth={140} sectionMaxWidth={157}>
                        { filteredProvider &&
                            filteredProvider.map((provider)=>{
                                let servicePrices = [];
                                servicePrices = this.props.services.map(service => {
                                    if (service.provider === provider.uid){
                                        return service && service.price;
                                    }
                                })
                                servicePrices = servicePrices.filter(price => price)
                                const lowestPrice = Math.min(...servicePrices);
                                // console.log('servicePrices', servicePrices)
                                // console.log('lowestPrice', lowestPrice)
                                                return (
                                                    <ProviderCard
                                                        provider={provider}
                                                        lowestPrice={lowestPrice}
                                                    />
                                                );
                            })
                        }
                    </FluidSection>
                    </div>
                }

            
            </div>
        );
    }
}



const mapStateToProps = ({provider, expert, service, company}) => {
    // console.log(`%c${JSON.stringify(company)}`,'color: gold');
    return {
        providers: provider.providers,
        services: service.services,
        serviceCategories: service.categories,
        serviceModules: service.serviceModules,
        companies: company.providerCompanies,
        serviceCategories: service.categories,
    };
}


export default connect(mapStateToProps, actions)(HeroSearch);



// WEBPACK FOOTER //
// ./src/js/components/Search/HeroSearch.jsx